import React from 'react';
import { Card } from 'antd';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';

import useCalendarPageLogic from './hooks/useCalendarPageLogic';
import Layout from '@components/layout';
import CalendarTitle from './CalendarTitle';
import CalendarContainer from './CalendarContainer';
import CalendarDevicesList from './CalendarDevicesList';
import ContentPreview from './ContentPreview';

function CalendarPage(props) {
  const { t } = useTranslation();
  const {
    editPlaylistId,
    showPreview,
    playlists,
    calendar,
    showDevices,
    toggleDevices,
    contents,
    allDevices,
    isOverModal,
    setOverModal,
    onSearch,
    onFilter,
    filter,
    filters,
    togglePreview,
    onFetchContents,
    onCopyCalendar,
    onRenameCalendar,
    onDeleteCalendar,
    onDeleteCalendarDevice,
    onAddDeviceToCalendar,
    onFetchDevices,
    onDeleteAllDevices,
    onAddPlaylistToCalendar,
    onDeletePlaylistFromCalendar,
    onChangeIntervals,
  } = useCalendarPageLogic();

  return (
    <div className="calendar-page">
      {!isEmpty(contents) && (
        <ContentPreview
          visible={showPreview}
          contents={contents}
          editPlaylistId={editPlaylistId}
        />
      )}

      <CalendarTitle
        {...calendar}
        t={t}
        allPlaylists={playlists}
        devicesCount={get(calendar, 'players.length', 0)}
        onCopy={onCopyCalendar(calendar.name)}
        onRename={onRenameCalendar(calendar.id)}
        onDelete={onDeleteCalendar(calendar.id)}
        onShowDevices={toggleDevices}
        onAddPlaylist={onAddPlaylistToCalendar}
      />
      <Card>
        <CalendarContainer
          {...calendar}
          t={t}
          allPlaylists={playlists}
          onChangeIntervals={onChangeIntervals}
          onDeletePlaylist={onDeletePlaylistFromCalendar}
          onAddPlaylistToCalendar={onAddPlaylistToCalendar}
          togglePreview={togglePreview}
          onFetchContents={onFetchContents}
          isOverModal={isOverModal}
          setOverModal={setOverModal}
        />
      </Card>
      <CalendarDevicesList
        t={t}
        allDevices={allDevices}
        devices={calendar.players}
        visible={showDevices}
        onClose={toggleDevices}
        onDelete={onDeleteCalendarDevice}
        onAdd={onAddDeviceToCalendar}
        onFetchDevices={onFetchDevices}
        onDeleteAllDevices={onDeleteAllDevices}
        filters={filters}
        onSearch={onSearch}
        onFilter={onFilter}
        filter={filter}
      />
    </div>
  );
}

export default CalendarPage;
